<template>
  <div>
    <el-row class="title-bar" type="flex" justify="space-between">
      <div class="vertical-center-box">
        <span class="title-h4 mr-r10">분석 결과 목록</span>
        <el-select class="mr-r4" style="width: 100px;" v-model="objDefineId">
          <el-option v-for="(item, index) in objDefineList" :key="index" :label="item.objDefineName" :value="item.objDefineId"></el-option>
        </el-select>
        <el-popover placement="bottom" trigger="click" v-model="showEventPopover">
          <el-row class="title-bar" type="flex" justify="end">
            <w-header-search-button size="mini" @click="popoverShowSearchTool = !popoverShowSearchTool"></w-header-search-button>
          </el-row>
          <el-scrollbar class="bar-visible">
            <el-table-wrapper style="height: 400px; width: 400px;" ref="popoverTable" v-loading="loading" :columns="targetObjColumn" :data="setTargetObjList"  @condition-change="loadPopoverRscTable"
            row-class-name="c-pointer" :show-search-tool="popoverShowSearchTool" :show-custom-header="true" :pagination="true" @cell-click="selectTargetObjInfo"  remote :total="objTotal">
            </el-table-wrapper>
          </el-scrollbar>
          <el-input class="c-pointer mr-r10" @click.native="clickInputButton" style="width:200px;" slot="reference" v-model="selectedEventHistLabel" placeholder="장비 선택" readonly>
            <i slot="suffix" v-if="selectedEventHistLabel !== null"
              class="el-input__icon el-icon-circle-close el-input__clear"
              @click="clickClearable"></i>
          </el-input>
        </el-popover>
        <!-- <span class="text-em">
          최근 수행일시: {{recentExecutionInfo}}
        </span> -->
      </div>
      <div class="vertical-center-box">
        <el-button class="drag mr-r4" size="mini" @click="onClickExportExcel">
          <img src="@/assets/img/icons/excel.png" style="position:relative;left:-2px;bottom:2px;">
          <span style="left:2px;bottom:5px;">  엑셀출력</span>
        </el-button>
        <w-header-search-button size="mini" @click="showSearchTool = !showSearchTool"></w-header-search-button>
      </div>
    </el-row>
    <div class="mr-t15">
      <el-table-wrapper :data="predictResultTableData" :columns="predictResultColumns" ref="predictResultTable" @condition-change="loadPredictAnalysisResult"
        remote :total="total" :pagination="true" style="width:100%;" :show-search-tool="showSearchTool" :show-custom-header="true">
        <template slot-scope="scope" slot="more-slot">
          <i class="c-pointer far fa-search-plus" @click="showPredictResultPopup(scope.row)"/>
        </template>
      </el-table-wrapper>
    </div>
    <w-predict-result-chart-popup :select-predict-result-obj="selectPredictResultObj" ref="predictResultChartPopup"></w-predict-result-chart-popup>
  </div>
</template>

<script>
import { isNil } from 'lodash';
import msgUtil from '@/utils/message';
import { EMPTY_TEXT, getValueAfterCheckEmpty } from '@/utils/string';
import EventRptApi from '@/api/event/event-rpt';
import { getDateToString } from '@/utils/date';
import { convertValuByUnit } from '@/utils/number';
import FileApi from '@/api/common/file';
import WPredictResultChartPopup from './popup/PredictResultChartPopup';

export default {
  name: 'WAnalysisResult',
  components: {
    WPredictResultChartPopup,
  },
  data() {
    return {
      EMPTY_TEXT,
      predictResultTableData: [],
      recentExecutionInfo: null,
      objDefineList: [],
      objDefineId: null,
      showSearchTool: false,
      showEventPopover: false,
      popoverShowSearchTool: false,
      loading: false,
      isSetInterval: true,
      targetObjParams: {},
      objTotal: 0,
      total: 0,
      setTargetObjList: [],
      selectedEventHistLabel: null,
      selectPredictResultObj: {},
      predictResultColumns: [
        {
          prop: 'objName',
          label: '장비',
          remoteProp: 'o.obj_name',
          sortable: true,
          searchable: true,
        },
        {
          prop: 'ipaddress',
          label: 'IP 주소',
          sortable: true,
          searchable: true,
          formatter: this.getTableValueAfterCheckEmpty,
        },
        {
          prop: 'managetypeName',
          label: '관리 구분',
          remoteProp: 'm.managetype_name',
          sortable: true,
          searchable: true,
          width: 100,
        },
        {
          prop: 'rsctypeName',
          label: '자원 구분',
          remoteProp: 'rt.rsctype_name',
          sortable: true,
          searchable: true,
        },
        {
          prop: 'rscName',
          label: '자원',
          remoteProp: 'r.rsc_name',
          sortable: true,
          searchable: true,
        },
        {
          prop: 'rscKeyName',
          label: '자원키',
          remoteProp: 'ork.rsc_key_name',
          sortable: true,
          searchable: true,
          width: 100,
        },
        {
          prop: 'conditionValue',
          label: '목표치',
          formatter: this.convertValue,
        },
        {
          prop: 'currentValue',
          label: '현재 값',
          formatter: this.convertValue,
          width: 100,
        },
        {
          prop: 'predictCheckDatetime',
          label: '예상 도달 시점',
          formatter: this.convertDateString,
        },
        {
          label: '더보기',
          headerAlign: 'center',
          align: 'center',
          scopedSlot: 'more-slot',
          width: 80,
          sortable: false,
        },
      ],
      targetObjColumn: [
        {
          prop: 'objDefineName',
          label: '관리 구분',
          remoteProp: 'obj.obj_define_name',
          sortable: true,
          searchable: true,
          width: 100,
        },
        {
          prop: 'objName',
          label: '장비명',
          remoteProp: 'obj.obj_name',
          sortable: true,
          searchable: true,
        },
        {
          prop: 'ipaddress',
          label: 'IP 주소',
          sortable: true,
        },
      ],
    };
  },
  watch: {
    objDefineId: {
      handler(value) {
        if (!isNil(value)) {
          this.showEventPopover = false;
          this.targetObjParams.objId = null;
          if (value === 'all') {
            this.targetObjParams.objDefineId = null;
          } else {
            this.targetObjParams.objDefineId = value;
          }
          this.loadPredictAnalysisResult();
        }
      },
      immediate: true,
    },
  },
  methods: {
    /**
     * 관련 데이터 loadData 함수
     * @author Song
     */
    loadData() {
      this.loadObjDefineTargetData();
      this.loadPopoverRscTable();
    },
    //
    loadObjDefineTargetData() {
      EventRptApi.getEventRptTargetObjDefine().then((response) => {
        if (response.data.success) {
          const objDefineList = [];
          const result = response.data.data;
          objDefineList.push({ objDefineName: '전체', objDefineId: 'all' });
          this.objDefineList = objDefineList.concat(result);
          this.objDefineId = this.objDefineList[0].objDefineId;
        } else {
          this.$message(msgUtil.getResultMsgData(msgUtil.action.VIEW, '예측 자원 관리 구분 목록', false));
        }
      });
    },
    //
    loadPopoverRscTable() {
      const tableParams = this.$refs.popoverTable.getParameter();
      const params = {
        objDefineId: this.targetObjParams.objDefineId,
        ...tableParams,
      };
      EventRptApi.getEventRptTargetObjInfo(params).then((response) => {
        if (response.data.success) {
          this.setTargetObjList = response.data.data;
          this.objTotal = response.data.total;
        } else {
          this.$message(msgUtil.getResultMsgData(msgUtil.action.VIEW, '예측 자원 목록', false));
        }
      }).catch((e) => {
        this.$message(msgUtil.getResultMsgData(msgUtil.action.VIEW, '예측 자원 목록', false));
        throw new Error(e);
      });
    },
    // 검색 필터링 컴포넌트 - 선택 이벤트
    selectTargetObjInfo(row) {
      this.showEventPopover = false;
      this.targetObjParams.objId = row.objId;
      this.targetObjParams.objDefineId = row.objDefineId;
      this.selectedEventHistLabel = `[${getValueAfterCheckEmpty(row.objName)}] ${getValueAfterCheckEmpty(row.ipaddress)}`;
      this.loadPredictAnalysisResult();
    },
    // 검색 필터링 컴포넌트 - 검색 초기화 함수
    clickClearable() {
      if (!isNil(this.selectedEventHistLabel)) {
        this.targetObjParams.objId = null;
        this.targetObjParams.objDefineId = (this.objDefineId === 'all') ? null : this.objDefineId;
        this.selectedEventHistLabel = null;
        this.loadPredictAnalysisResult();
      }
    },
    clickInputButton() {
      this.loadPopoverRscTable();
    },
    /**
     * 장애 예측 분석 결과를 조회한다.
     * @author Song
     */
    loadPredictAnalysisResult() {
      this.$nextTick(() => {
        const tableParams = this.$refs.predictResultTable.getParameter();
        const params = {
          ...this.targetObjParams,
          ...tableParams,
        };
        EventRptApi.getEventRptResultList(params).then((res) => {
          if (res.data.success) {
            this.predictResultTableData = res.data.data;
            this.total = res.data.total;
          }
        });
      });
    },
    getTableValueAfterCheckEmpty(row, column, value) {
      return getValueAfterCheckEmpty(value);
    },
    /**
     * 장애 예측 분석 - 결과 차트 팝업을 띄운다.
     * @author Song
     */
    showPredictResultPopup(row) {
      this.selectPredictResultObj = row;
      if (row.objManagetypeId === 'E2E') {
        this.selectPredictResultObj.rsctypeKey = row.rscKey;
      }
      this.$nextTick(() => {
        this.$refs.predictResultChartPopup.open();
      });
    },
    /**
     * 장애 예측 분석 - 현재 값 단위 변환
     * @author Song
     */
    convertValue(row, column, value) {
      return isNil(value) ? EMPTY_TEXT : convertValuByUnit(value, row.rscUnit, false);
    },
    /**
     * 장애 예측 분석 - 문자열 날짜포맷 변경
     * @author Song
     */
    convertDateString(row, column, value) {
      return isNil(value) ? EMPTY_TEXT : getDateToString(Date.parse(value), 'YYYY-MM-DD');
    },
    /**
     * 장애 예측 분석 - 분석 결과 엑셀 출력
     * @author Song
     */
    onClickExportExcel() {
      this.$emit('excel-loading', true);
      const tableParams = this.$refs.predictResultTable.getParameter();
      delete tableParams.start;
      delete tableParams.limit;
      const params = {
        ...tableParams,
      };
      EventRptApi.excelExportEventRptResultList(params)
        .then((response) => {
          if (response.data.success && !isNil(response.data.data)) {
            FileApi.downloadExportedExcelFile(response.data.data);
          } else {
            this.$message(msgUtil.getResultMsgData('출력', '엑셀', false));
          }
        })
        .catch(() => {
          this.$message(msgUtil.getResultMsgData('출력', '엑셀', false));
        }).finally(() => {
          this.$emit('excel-loading', false);
        });
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/views/event/components/AnalysisResult.vue